import { Button } from "@/components/ui/button";
import { getUserRoles } from '@/utils/auth';
import { ArrowLeft } from "lucide-react";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const CSAWTermsConditionsPrintPage = () => {
   const navigate = useNavigate();

   let check = 0;
   useEffect(() => {
      check++;
      if (check === 1) {
         toast.info('Please wait while we print the terms and conditions...', { duration: 3000, position: 'top-center' });
         setTimeout(() => {
            window.print();
         }, 3500);
      }
   }, []);

   const handleBack = () => {
      const userRoles = getUserRoles();
      if (userRoles.includes('Technical_Staff')) {
         navigate("/personnel/technical-staff");
      } else {
         navigate("/personnel/dashboard");
      }
   };

   return (
      <div className="print-page bg-white dark:bg-gray-900 min-h-screen flex flex-col" style={{ fontFamily: 'Times New Roman' }}>
         {/* Back Button - will be hidden during print */}
         <div className="fixed top-4 left-4 no-print">
            <Button
               variant="outline"
               onClick={handleBack}
               className="flex items-center gap-2"
            >
               <ArrowLeft className="h-4 w-4" />
               Back
            </Button>
         </div>

         <div className="terms-page flex-1 flex flex-col justify-center max-w-3xl mx-auto px-8">
            <div className="terms-header text-center text-lg mb-6 underline dark:text-gray-100">
               TERMS AND CONDITIONS
            </div>
            <div className="terms-content space-y-6 text-justify px-8 dark:text-gray-300">
               <p>
                  The registered chainsaw shall be used for legitimate purposes only.
                  Unauthorized use of the chainsaw shall be ground for the cancellation
                  of this Certificate of Registration.
               </p>
               <p>
                  THE PENRO concerned or nearest DENR office should be informed in writing
                  within (3) calendar days if the registered chainsaw was lost.
               </p>
               <p>
                  In case of unserviceable chainsaws, the owner shall immediately report
                  the same to the PENRO concerned and request for the revocation of the
                  Certificate of Registration provided that if the Certificate of Registration
                  has expired, the owner shall notify the PENRO in writing that he/she is no
                  longer renewing the Certificate of Registration.
               </p>
            </div>
         </div>

         <style>
            {`
              @media print {
                @page {
                  size: A4;
                  margin: 15mm;
                }
                .no-print {
                  display: none !important;
                }
                body {
                  margin: 0;
                  padding: 0;
                  font-family: 'Times New Roman', Times, serif;
                }
                .terms-page {
                  min-height: 100vh;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                }
                .terms-header {
                  font-size: 14pt;
                  // font-weight: bold;
                  margin-bottom: 20px;
                }
                .terms-content {
                  font-size: 12pt;
                  line-height: 1.5;
                }
                .terms-content p {
                  margin-bottom: 15px;
                }
                /* Reset dark mode styles for printing */
                .dark\\:bg-gray-900 {
                  background-color: white !important;
                }
                .dark\\:text-gray-100,
                .dark\\:text-gray-300 {
                  color: black !important;
                }
              }
            `}
         </style>
      </div>
   );
};

export default CSAWTermsConditionsPrintPage;
